import type { SetupTourDefinition } from '../core/types';

export const VEHICLE_GROUPS_SETUP_TOUR_TARGETS = {
  sidebarVehicleGroupsLink: 'fleet-sidebar-vehicle-groups-link',
  addGroupButton: 'fleet-groups-list-add-button',
  groupCreateForm: 'fleet-group-create-form',
  groupSubmitButton: 'fleet-group-submit-button',
} as const;

export const vehicleGroupsSetupTour: SetupTourDefinition = {
  id: 'vehicle_groups_setup',
  label: 'Vehicle Groups',
  onboardingKey: 'vehicle_groups_setup',
  sidebarTargetsByRoute: {
    '/vehicle-groups': VEHICLE_GROUPS_SETUP_TOUR_TARGETS.sidebarVehicleGroupsLink,
  },
  steps: [
    {
      id: 'sidebar-groups',
      route: '/vehicle-groups',
      target: VEHICLE_GROUPS_SETUP_TOUR_TARGETS.sidebarVehicleGroupsLink,
      content: 'Click Vehicle Groups to start fleet setup',
      advanceOnTargetClick: true,
      expandSidebarKeys: ['/fleet'],
    },
    {
      id: 'add-group',
      route: '/vehicle-groups',
      target: VEHICLE_GROUPS_SETUP_TOUR_TARGETS.addGroupButton,
      content: 'Click Add New Group to create your first vehicle group',
      advanceOnTargetClick: true,
    },
    {
      id: 'group-form',
      route: '/vehicle-groups/create',
      target: VEHICLE_GROUPS_SETUP_TOUR_TARGETS.groupCreateForm,
      content: 'Select the Vehicle Type and enter a Group Name',
      showRequiredFieldsOnEnter: true,
      directNextTargets: [VEHICLE_GROUPS_SETUP_TOUR_TARGETS.groupSubmitButton],
      next: {
        label: 'Create',
        guardTarget: VEHICLE_GROUPS_SETUP_TOUR_TARGETS.groupCreateForm,
        action: { type: 'submit' },
        waitForTargetRemoval: VEHICLE_GROUPS_SETUP_TOUR_TARGETS.groupCreateForm,
        completesTour: true,
      },
    },
  ],
};
